var React = require('react');

function Stars (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M5.04386 24.5727L13.1579 0.832031L21.2719 24.5727L0 9.89097H26.3158","fill":"white","key":0}),React.createElement("path",{"d":"M48.0439 24.5727L56.1579 0.832031L64.2719 24.5727L43 9.89097H69.3158","fill":"white","key":1}),React.createElement("path",{"d":"M91.0439 24.5727L99.1579 0.832031L107.272 24.5727L86 9.89097H112.316","fill":"white","key":2})]);
}

Stars.defaultProps = {"width":"113","height":"25","viewBox":"0 0 113 25","fill":"none"};

module.exports = Stars;

Stars.default = Stars;
